import React from "react";
import Image from "next/image";
import { BASE_ASSETS_URL } from "../../../constants/constants";

const AlternativeImages = ({ image }) => {
  return (
    <figure className="relative w-full mb-4 flex flex-col gap-2">
      <Image
        src={`${BASE_ASSETS_URL}/v2/alternatives${image.src}`}
        width="10"
        height="10"
        className="w-full h-auto object-cover border"
        alt={image?.alt}
      />
      {image?.caption && (
        <figcaption className="text-center px-6 sm:px-10 text-xs sm:text-sm italic">
          {image?.caption}
        </figcaption>
      )}
    </figure>
  );
};

export default AlternativeImages;
